/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { ActivityLevel } from "../models/ActivityLevel";
import type { DataMessageResponse_ActivityLevel_ } from "../models/DataMessageResponse_ActivityLevel_";
import type { DataResponse_ActivityLevel_ } from "../models/DataResponse_ActivityLevel_";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class ActivityLevelService {
  /**
   * Update Activity Level
   * Updates the activity level for a user.
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_ActivityLevel_ Successful Response
   * @throws ApiError
   */
  public static updateActivityLevelApiV1ActivityLevelPut(
    xUserId: string,
    requestBody: ActivityLevel,
  ): CancelablePromise<DataMessageResponse_ActivityLevel_> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/activity-level",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Activity Level
   * Returns the activity level for a user.
   * @param xUserId
   * @returns DataResponse_ActivityLevel_ Successful Response
   * @throws ApiError
   */
  public static getActivityLevelApiV1ActivityLevelGet(
    xUserId: string,
  ): CancelablePromise<DataResponse_ActivityLevel_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/activity-level",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Activity Level By Admin
   * Used by an admin to get information about a user's activity level.
   * @param userId
   * @returns DataResponse_ActivityLevel_ Successful Response
   * @throws ApiError
   */
  public static getActivityLevelByAdminApiV1ActivityLevelUserIdGet(
    userId: string,
  ): CancelablePromise<DataResponse_ActivityLevel_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/activity-level/{user_id}",
      path: {
        user_id: userId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
